import { IntlMoney } from "@funcional/react-intl-ui"
import { IRefundTransaction } from "../contracts"
import React from "react"

interface IModalItem {
    pbmSales: IRefundTransaction,
    item: string,
    title: string,
    style: React.CSSProperties,
};

export function ModalItem({ pbmSales, item, title, style }: IModalItem) {
    const pbmSalesProducts = pbmSales.pbmSalesProducts;
    const commonStyle: React.CSSProperties = {
        marginBottom: "8px", 
        borderBottom: "1px solid white",
    };

    const resultByItem = (saleQuantity, refundAmount, product) => {
        if(item === "productCode") return `${product[item]} ${saleQuantity}`;
        if(item === "refundAmount") return refundAmount;
        return product[item];
    };

    return (
        <div style={{...style}}>
            <p style={commonStyle}>{title}</p>
            {pbmSalesProducts.map((product, index) => {
                const saleQuantity = pbmSalesProducts[index].saleQuantity > 0 ? ` (${pbmSalesProducts[index].saleQuantity} un)` : "";
                const refundAmountIsValid = pbmSalesProducts[index][item] !== "0" && pbmSalesProducts[index][item] ? <IntlMoney value={pbmSalesProducts[index][item]}/> : "-";
                const refundAmount = pbmSales.canceledTransactionDate ? "R$ 0,00" : refundAmountIsValid;
                
                return (
                    <div key={index} style={
                        item === "refundStatus" ?  {
                            marginBottom: "4px", color: 
                            product[item] !== "CALCULADA" && 
                            product[item] !== "RECALCULADA" ? "#f07878" : "#9ACD32", 
                            fontWeight: "bold"
                        } : { marginBottom: "4px" }
                    }>
                        {product[item] && product[item] !== "0"  ? resultByItem(saleQuantity, refundAmount, product) : "-"}
                    </div>
                )
            })}
        </div>
    )
}